<ng-container *ngIf="!loading">
    <div class="w-100" [ngStyle]="{'height.px': height}">
        <table class="table table-hover" id="newsTble">
            <tr *ngFor="let news of data | async; index as i">
                <td>
                    <div class="custom-control custom-control-primary custom-checkbox">
                        <input type="checkbox" class="custom-control-input" [id]="'colorCheck1'+i" (change)="addnews(news)" />
                        <label class="custom-control-label" [for]="'colorCheck1'+i"></label>
                    </div>
                </td>
                <td>
                    <div class="text-nowrap">
                        <span>{{news?.published_utc | date : 'MM/dd/yyyy hh:mm a'}}</span>
                    </div>
                </td>
                <td>
                    <div class="d-flex flex-column text-left">
                        <a target="_blank" [href]="news?.article_url">
                            {{news?.title}}
                        </a>
                    </div>
                </td>
            </tr>
        </table>
    </div>    
    <app-toast-container2 aria-live="polite" aria-atomic="true"></app-toast-container2>
</ng-container>
<ng-container *ngIf="loading">
    <div [ngStyle]="{'height.px': height}" class="d-flex flex-column justify-content-center align-items-center" *ngIf="loading">
        <div class="spinner-border" role="status" *ngIf="!data?.value">
            <span class="sr-only">Loading...</span>
        </div>
        <div *ngIf="data?.value">
            <h1>{{data?.value}}</h1>
        </div>
    </div>
</ng-container>
